export default __webpack_public_path__ + "static/media/gray.87322a5f.svg";